/**
 * @flow
 * @relayHash d0aedcf9c24282f23958068134697d3d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type draftAnswersInputType = {|
  guest_id: string,
  event_id: string,
|};
export type LeaderboardTableQueryVariables = {|
  draftArguments?: ?draftAnswersInputType
|};
export type LeaderboardTableQueryResponse = {|
  +getDraftAnswers: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?$ReadOnlyArray<?{|
      +_id: ?string,
      +option_name: ?string,
      +points: ?number,
    |}>,
  |}
|};
export type LeaderboardTableQuery = {|
  variables: LeaderboardTableQueryVariables,
  response: LeaderboardTableQueryResponse,
|};
*/


/*
query LeaderboardTableQuery(
  $draftArguments: draftAnswersInputType
) {
  getDraftAnswers(draftArguments: $draftArguments) {
    code
    message
    data {
      _id
      option_name
      points
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "draftArguments",
    "type": "draftAnswersInputType",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getDraftAnswers",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "draftArguments",
        "variableName": "draftArguments"
      }
    ],
    "concreteType": "draftAnswersType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "draftAnswersDataType",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "option_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "points",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LeaderboardTableQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LeaderboardTableQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "LeaderboardTableQuery",
    "id": null,
    "text": "query LeaderboardTableQuery(\n  $draftArguments: draftAnswersInputType\n) {\n  getDraftAnswers(draftArguments: $draftArguments) {\n    code\n    message\n    data {\n      _id\n      option_name\n      points\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a19e64ab940bd49470ebbf72e0c1fb7e';
module.exports = node;
